import React, { useState } from "react";
import { motion } from "framer-motion";
import "./join.scss";
import Joinmodal from "../modals/Joinmodal";
import Registermodal from "../modals/Registermodal";
const Join = () => {
  const [modals, setModals] = useState({
    join: false,
    register: false,
  });

  const closeModal = (name) =>
    setModals((prev) => ({ ...prev, [name]: false }));
  return (
    <>
      <section className="mainjoin">
        <img
          src="/assets/join/darkershade.png"
          alt="darkershade"
          className="darkershade"
        />
        <video
          className="mainjoinvideo"
          muted="muted"
          playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="/assets/join/join.mp4" type="video/mp4" />
        </video>
        <div className="custom-container">
          <div className="maincontenttext">
            <span>Get Started</span>
            <h2>Join the Future of Transparent Market Data</h2>
            <p>
              Access verified company data, transparent trading activity, and
              identity-verified investor discussions or register your company to
              publish and verify share structure data on TraqStock.
            </p>
            <div className="lastbutton">
              <button
                onClick={() => {
                  window.location.href = "https://app.traqstock.com";
                }}
                className="acess"
              >
                Join as Investor
              </button>
              <button
                onClick={() => {
                  window.location.href = "https://agent.traqstock.com";
                }}
                className="early"
              >
                Join as Company Agent
              </button>
            </div>
          </div>
        </div>
      </section>

      <Joinmodal show={modals.join} onHide={() => closeModal("join")} />
      <Registermodal
        show={modals.register}
        onHide={() => closeModal("register")}
      />
    </>
  );
};

export default Join;
